export const TRC_NAVBAR_VALUES = {
    LESSON_PLANS:"LESSON PLANS",
    PROGRESSIVE_LESSON_PLANS:"PROGRESSIVE LESSON PLANS",
    VIDEOS:"VIDEOS",
    RESOURCES:"RESOURCES",
    VIEW_ALL:"VIEW ALL"
}
